import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useLazyQuery } from '@apollo/react-hooks';
import {
  PerformanceRuleImpressions,
  PerformanceRuleImpressionsVariables
} from './__generated__/PerformanceRuleImpressions';

export const PERFORMANCE_RULES_IMPRESSIONS_QUERY = gql`
  query PerformanceRuleImpressionsQuery($campaignId: ID!, $dateRange: DateRangeEnum!, $articleIds: [String!]) {
    performanceRuleImpressions(campaignId: $campaignId, dateRange: $dateRange, articleIds: $articleIds) {
      key
      value
    }
  }
`;

export const usePerformanceRuleImpressionsLazyQuery = () => {
  return useLazyQuery<PerformanceRuleImpressions, PerformanceRuleImpressionsVariables>(
    PERFORMANCE_RULES_IMPRESSIONS_QUERY,
    {
      client: kmsClient,
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true
    }
  );
};
